import WsProvider from './provider/WSProvider'

var base64 = require('base64_js');
var userData5B = localStorage.getItem("userData5B") ? JSON.parse(decodeURI(base64.decode(localStorage.getItem("userData5B")))) : "";

var serviceName = "index";
var sliderService = {
    imageUrlBuyuk: WsProvider.resim + "/" + userData5B["firmaKodu"] + "/buyuk/",
    imageUrlOrta: WsProvider.resim + "/" + userData5B["firmaKodu"] + "/orta/",
    imageUrlKucuk: WsProvider.resim + "/" + userData5B["firmaKodu"] + "/kucuk/",
    imageUrlEnKucuk: WsProvider.resim + "/" + userData5B["firmaKodu"] + "/enkucuk/",
    path  : "https://www.5bmuhendislik.com.tr/",
    bg  : "https://www.5bmuhendislik.com.tr/resimler/slider.jpg",
    sliderTanimlama(oncekiSliderKodu, resim, anaBaslik, altBaslik, aciklama,link1,linkButon1,link2,linkButon2,durum) {
        var userData5B = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userData5B"))));
        var param = {
            data: {
                yonetimId: userData5B["yonetimId"],
                userToken: userData5B["token"],
                firmaKodu: userData5B["firmaKodu"],
                oncekiSliderKodu: oncekiSliderKodu,
                resim: resim,
                anaBaslik: anaBaslik,
                altBaslik: altBaslik,
                aciklama: aciklama,
                linkButon1: linkButon1,
                link1: link1,
                linkButon2: linkButon2,
                link2: link2,
                durum: durum,
                serviceName: "slider",
                methodName: "sliderTanimlama"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },

    sliderList(durum, baslangic, limit) {
        var userData5B = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userData5B"))));
        var param = {
            data: {
                yonetimId: userData5B["yonetimId"],
                userToken: userData5B["token"],
                firmaKodu: userData5B["firmaKodu"],
                durum: durum,
                baslangic: baslangic,
                limit: limit,
                serviceName: "slider",
                methodName: "sliderList"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },

    sliderKisaList() {
        var userData5B = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userData5B"))));
        var param = {
            data: {
                yonetimId: userData5B["yonetimId"],
                userToken: userData5B["token"],
                firmaKodu: userData5B["firmaKodu"],
                serviceName: "slider",
                methodName: "sliderKisaList"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },

    sliderDetay(sliderId) {
        var userData5B = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userData5B"))));
        var param = {
            data: {
                yonetimId: userData5B["yonetimId"],
                userToken: userData5B["token"],
                firmaKodu: userData5B["firmaKodu"],
                sliderId: sliderId,
                serviceName: "slider",
                methodName: "sliderDetay"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },

    sliderDurumGuncelle(sliderId, durum) {
        var userData5B = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userData5B"))));
        var param = {
            data: {
                yonetimId: userData5B["yonetimId"],
                userToken: userData5B["token"],
                firmaKodu: userData5B["firmaKodu"],
                sliderId: sliderId,
                durum: durum,
                serviceName: "slider",
                methodName: "sliderDurumGuncelle"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },

    sliderGuncelle(sliderId, updateList) {
        var userData5B = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userData5B"))));
        var param = {
            data: {
                yonetimId: userData5B["yonetimId"],
                userToken: userData5B["token"],
                firmaKodu: userData5B["firmaKodu"],
                sliderId: sliderId,
                updateList: updateList,
                serviceName: "slider",
                methodName: "sliderGuncelle"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },

}

export default sliderService

